// @flow
import React from 'react';
import { AppLink } from '@finect/tabular-core/AppLink';
import { Modal } from '@finect/tabular-components/Modal';
import { getLoginBaseURL } from '@finect/front-utils/getLoginBaseURL';
import { Title, Message, Claim, Actions, ActionsLogin, ActionsFooter, Wrapper, ContentWrapper } from './partials';
import { LoginButton } from './LoginButton';

const settingsPath = `https://${
  ['develop', 'stage'].includes(process.env.FINECT_TARGET || 'production')
    ? 'stage-'
    : `${process.env.FINECT_BASEURL || 'www.finect.com'}/usuario/configuracion`
}`;

export const ArticleOnlyForProfessionalInteractionModal = ({
  user,
  onClose,
  show
}: {
  user: Object,
  onClose: Function,
  show: boolean
}) => {
  const { isLoggedIn } = user;
  return (
    <Modal onClose={onClose} show={show}>
      <Wrapper>
        <ContentWrapper>
          <Claim isLoggedIn={isLoggedIn}>
            <Title>
              {isLoggedIn
                ? 'Este artículo sólo está disponible para usuarios profesionales'
                : 'Para seguir leyendo este artículo, crea tu cuenta profesional'}
            </Title>
            {!isLoggedIn ? (
              <Message>Lo sentimos pero este artículo sólo está disponible para usuarios profesionales.</Message>
            ) : (
              <Message>
                {' '}
                Si eres un profesional de las finanzas y quieres tener acceso a todo nuestro contenido exclusivo para
                profesionales, debes ir a tu <AppLink href={settingsPath}>configuración</AppLink> e indicárnoslo.
              </Message>
            )}
          </Claim>

          {!isLoggedIn ? (
            <Actions>
              <ActionsLogin>
                <LoginButton strategy="facebook" />
                <LoginButton strategy="linkedin" />
                <LoginButton strategy="google" />
                <LoginButton strategy="email" />
              </ActionsLogin>

              <ActionsFooter>
                <AppLink href={getLoginBaseURL()} rel="nofollow">¿Ya tienes cuenta con nosotros?</AppLink>
              </ActionsFooter>
            </Actions>
          ) : null}
        </ContentWrapper>
      </Wrapper>
    </Modal>
  );
};
